import { FONT, RADIUS } from "@/styles/common";
import { Box, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const Wrapper = styled(Box)`
    position: relative;
    width: 720px;
    height: 640px;
    overflow: auto;
    ${RADIUS(4)}

    @media (max-width:${({ theme }) => theme.MEDIA.tablet}) {
        width: 480px;
    }

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        width: 320px;
    }
`;

export const CustomText = styled(Text)`
    ${FONT("pretendard", 24, 500)}
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.bgColor[300]};
`;
